import http from '../../axios';
import {Player} from "@/store/player/types";
import {PaidFeatureDto} from "@/store/paidFeature/types";
import {SceneService} from "@/services/scene-service";
import PlayerStore from "@/store/player";

export default class PaidFeatureStore {

    public static getPaidFeatureInfo(): Promise<PaidFeatureDto> {
        return http.get('/api/paidFeature/getInfo')
            .then(r => r.data)
            .then(paidFeatureObj => {
                return Object.assign(new PaidFeatureDto(), paidFeatureObj);
            });
    }

    public static changeGender(): Promise<Player> {
        return http.post('/api/paidFeature/changeGender')
            .then(r => r.data)
            .then(playerObj => {
                let player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
                return player;
            });
    }

    public static renamePlayer(name: string): Promise<void> {
        var params = new URLSearchParams();
        params.append('name', name);
        return http.post('/api/paidFeature/renamePlayer', params)
            .then((response) => {
                SceneService.reloadScene();
            });
    }
}
